const EVENT_STATUSES = {
  APPROVED: 'COURSE_PLAN_APPROVED',
  REJECTED: 'COURSE_PLAN_REJECTED',
  FORCED_REVIEW: 'COURSE_PLAN_FORCED_REVIEW',
};

export default EVENT_STATUSES;
